import { Button, CircularProgress } from '@mui/material';
import { ButtonContainer } from '../styles';
import { MouseEventHandler } from 'react';

export const ProvisionSection: React.FC<{
  handleToggleAdvanced?: MouseEventHandler<HTMLElement>;
  disableProvisionButton: boolean;
  showAdvancedSetting?: boolean;
  onProvisionClick: VoidFunction;
  showAdvanceButton?: boolean;
  onForceProvision?: VoidFunction;
  isLoading?: boolean;
}> = ({
  onProvisionClick,
  disableProvisionButton,
  handleToggleAdvanced,
  showAdvancedSetting,
  showAdvanceButton = true,
  onForceProvision,
  isLoading = false,
}) => {
  return (
    <ButtonContainer>
      {/* Primary action - filled button */}
      <Button
        variant="contained"
        color="primary"
        onClick={onProvisionClick}
        disabled={disableProvisionButton}
        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : undefined}
        sx={{
          minWidth: 120,
          textTransform: 'none',
          fontWeight: 600,
        }}
      >
        {isLoading ? 'Provisioning...' : 'Provision'}
      </Button>

      {/* Secondary action - outlined button */}
      {onForceProvision && (
        <Button
          variant="outlined"
          color="warning"
          onClick={onForceProvision}
          disabled={disableProvisionButton}
          sx={{
            minWidth: 140,
            textTransform: 'none',
            fontWeight: 500,
            borderWidth: 1.5,
            '&:hover': {
              borderWidth: 1.5,
            },
          }}
        >
          Force Provision
        </Button>
      )}

      {/* Tertiary action - text button */}
      {showAdvanceButton ? (
        <Button
          variant="text"
          color="primary"
          onClick={handleToggleAdvanced}
          disabled={disableProvisionButton}
          sx={{
            minWidth: 100,
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          {showAdvancedSetting ? 'Hide Advanced' : 'Advanced'}
        </Button>
      ) : null}
    </ButtonContainer>
  );
};
